import { formatDateToISOShort } from '../../common/utilities/FormatDate'

/**
 * Whether `date` from the pre-register form is a single calendar day.
 * Multi-day ranges (`[start, end]` with different ISO dates) must not use
 * the Dexie network-fallback: create_range stores `uuid:YYYY-MM-DD` per day.
 */
export function isSingleInvitationDay(date) {
  if (!Array.isArray(date)) return true
  if (!date[0] || !date[1]) return true
  return formatDateToISOShort(date[0]) === formatDateToISOShort(date[1])
}

/**
 * Network / server errors that are safe to enqueue locally.
 * 4xx (including 401) are explicit rejections — do not persist them in Dexie.
 */
export function isRetryableInvitationNetworkError(error) {
  const status = error?.response?.status
  return !status || status >= 500
}
